import { Person } from "./person/Person";

export class VipEntry {
    id: number
    buyer_id: number
    transactor_id: number
    niaga_usage_fee: number | null
    niaga_delta_boost: number | null
    is_mill_vip: boolean
    person?: Person

    constructor(data: any) {
        this.id = data.id
        this.buyer_id = data.buyer_id
        this.transactor_id = data.transactor_id
        this.niaga_usage_fee = data.niaga_usage_fee ?? null
        this.niaga_delta_boost = data.niaga_delta_boost ?? null
        this.is_mill_vip = data.is_mill_vip
        this.person = data.person ? Person.build(data.person) : undefined
    }

    static build(data: any): VipEntry {
        return new VipEntry(data)
    }
}
